import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {paymentActions} from 'actions';
import {PaymentMethods} from 'helpers/constants';
import {Loading} from 'Common/Structure';
import * as alerts from 'actions/alertActions';

class PayPal extends React.Component {
  state = {loading: false};

  handleClick = async () => {
    this.setState({loading: true});
    const result = await this.props.initiatePayment(
      this.props.amount,
      this.props.estimateId,
      this.props.invoiceId,
      PaymentMethods.PayPal,
    );
    if (result && result.data && result.data.payPalUrl) {
      window.top.location.href = result.data.payPalUrl;
    } else {
      this.setState({loading: false});
      this.props.errorAlert('Unable to pay with PayPal');
    }
  };

  render() {
    return this.state.loading ? (
      <Loading inline />
    ) : (
      <a onClick={this.handleClick} style={{cursor: 'pointer'}}>
        <img
          alt="Check out with PayPal"
          src="https://www.paypalobjects.com/webstatic/en_US/i/buttons/checkout-logo-large.png"
        />
      </a>
    );
  }
}

PayPal.defaultProps = {
  amount: 0,
  estimateId: null,
  invoiceId: null,
};

PayPal.propTypes = {
  amount: PropTypes.number,
  estimateId: PropTypes.number,
  invoiceId: PropTypes.number,

  //functions
  errorAlert: PropTypes.func.isRequired,
  initiatePayment: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      errorAlert: alerts.error,
      initiatePayment: paymentActions.initiatePayment,
    },
    dispatch,
  );

export default connect(
  null,
  mapDispatchToProps,
)(PayPal);



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/PayPal.js